import React, { useCallback, useState } from 'react';
import { Switch } from 'antd';
import { connect } from 'react-redux';

import { tableColumn } from 'utils';
import { TableList, ActionButton, PropValue } from 'components/common';
import PropertyValue from '../PropertyValue';
import PropertyType from '../PropertyType';


const PropertyList = ({ router, columnList, defaultFilter, activeFilter, topActions, actions, property }) => {
  const defaultColumnList = ['name', 'slug', 'type', 'sort', 'is_active', 'actions'];
  if (!columnList) {
    columnList = defaultColumnList;
  }
  const [itemIdForUpdate, setItemIdForUpdate] = useState(null);
  const columnByName = {
    id: tableColumn('ID', 'id', {
      sorter: true,
      width: 59,
    }),
    name: tableColumn('Название', 'name', {
      render: (val, item) => (
        <div>
          <PropertyValue detail={item} asLink={true} isBack={true} />
          <PropValue label="EXT_ID" value={item.ext_id}/>
        </div>
      ),
      sorter: true,
    }),
    slug: tableColumn('Код', 'slug', {
      width: 150,
      sorter: true,
    }),
    type: tableColumn('Тип', 'type', {
      render: (val, item) => <PropertyType value={val}/>,
      width: 80,
      sorter: true,
    }),
    sort: tableColumn('Сортировка', 'sort', {
      width: 80,
      sorter: true,
    }),
    is_active: tableColumn('Активен', 'is_active', {
      sorter: true,
      width: 150,
      render: (val, item) => (
        <div>
          <Switch
            style={{ marginTop: '5px', minWidth: '62px' }}
            checkedChildren="вкл"
            unCheckedChildren="выкл"
            checked={item.is_active}
            loading={property.updateStatus.isLoading && itemIdForUpdate === item.id}
            onClick={() => onPropertyOnOff(item)}
          />
        </div>
      ),
    }),
    actions: tableColumn('', 'actions', {
      align: 'right',
      render: (val, item) => (
        <ActionButton detail={item} modelActions={actions.property} actions={[{ name: 'edit' }, { name: 'delete' }]} />
      ),
    }),
  };

  const [selected, setSelected] = useState([]);

  const onLoad = useCallback(
    ({ query, activeFilter }) => {
      if (activeFilter === undefined) {
        activeFilter = property.filter.activeFilter;
      }
      actions.property.listLoad({ query, activeFilter, locationChange: true });
      setSelected([]);
    },
    [property, actions, setSelected],
  );

  const onPropertyOnOff = (item) => {
    const data = {
      id: item.id,
      is_active: !item.is_active,
      preventLoadDetail: true,
    };
    setItemIdForUpdate(item.id);
    actions.property.update(data);
  };

  const batchDelete = (selected) => {
    actions.property.batchDelete({ selected });
  };

  return (
    <TableList
      location={router.location}
      model={property}
      defaultFilter={defaultFilter}
      activeFilter={activeFilter}
      columnList={columnList}
      columnByName={columnByName}
      onLoadData={onLoad}
      topActions={topActions}
      showSearch={true}
      selected={selected}
      rowSelection={{
        selectedRowKeys: selected,
        onChange: (selectedRowKeys, selectedRows) => {
          setSelected(selectedRowKeys.slice());
        },
      }}
      rowActions={[
        {
          title: 'Удалить',
          icon: 'delete',
          action: (selected) => batchDelete(selected),
        },
      ]}
      filterFields={{
        list: ['is_active'],
        byName: {
          is_active: {
            label: 'Активно',
            type: 'bool',
          },
        },
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  property: state.property,
});

const mapDispatch = (dispatch) => ({
  actions: {
    property: dispatch.property,
  },
});

export default connect(mapState, mapDispatch)(PropertyList);
